import { getLeftNavGroupFoldersStore } from '../store/store';
import { GroupFolder } from 'owa-groups-services/lib/groups-rest-apis/schema/GroupFolder';

/**
 * @param groupId Smtp address of the group
 * @param folderId Folder Id of the group folder
 * @returns Group folder corresponding to the Folder Id of the specified group
 */
export function getGroupFolder(groupId: string, folderId: string): GroupFolder | undefined {
    let folder: GroupFolder | undefined;
    if (groupId && folderId) {
        folder = getLeftNavGroupFoldersStore()
            .folderTable?.get(groupId.toLowerCase())
            ?.folderHierarchy?.get(folderId);
    }
    return folder;
}
